import { defineComponent as _defineComponent } from 'vue'

export enum OzContainedButtonColorScheme {
  Bare = 'Bare',
  Primary = 'Primary',
  PrimaryPulsing = 'PrimaryPulsing',
  Secondary = 'Secondary',
  SecondaryActive = 'SecondaryActive',
  SecondaryContrast = 'SecondaryContrast',
  SecondaryClear = 'SecondaryClear',
  SecondaryClearText = 'SecondaryClearText',
  SecondaryDestructive = 'SecondaryDestructive',
  SecondaryClearActive = 'SecondaryClearActive',
  SecondaryLightHover = 'SecondaryLightHover',
  Alternative = 'Alternative',
  AlternativeSecondary = 'AlternativeSecondary', // Alternative2 in Figma
  AlternativeHeavy = 'AlternativeHeavy',
  Green = 'Green',
  Orange = 'Orange',
  Destructive = 'Destructive',
  DestructiveClear = 'DestructiveClear',
  Active = 'Active',
  Transparent = 'Transparent',
  Grey = 'Grey',
  Purple = 'Purple',
  Blue = 'Blue',
  BlueClear = 'BlueClear',
  GreenClear = 'GreenClear',
}

export enum OzContainedButtonSizePreset {
  Bare = 'Bare',
  H80px = 'H80px',
  H64px = 'H64px',
  H56px = 'H56px',
  H40px = 'H40px',
  H32px = 'H32px',
  H24px = 'H24px',
  H32pxW56px = 'H32pxW56px',
  H40W124px = 'H40W124px',
}

export { OzBaseButtonHrefMode as OzContainedButtonHrefMode } from '@@/library/v4/components/OzBaseButton.vue'
const __default__ = {}

import OzBaseButton, { OzBaseButtonHrefMode } from '@@/library/v4/components/OzBaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzContainedButton',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean, default: false },
    href: { default: undefined },
    hrefMode: { default: OzBaseButtonHrefMode.Default },
    colorScheme: { default: OzContainedButtonColorScheme.Primary },
    sizePreset: { default: OzContainedButtonSizePreset.H40px },
    text: { default: undefined },
    title: { default: undefined },
    centerText: { type: Boolean, default: false },
    shouldTruncateText: { type: Boolean, default: true },
    autoHeight: { type: Boolean, default: false },
    ringOffsetColorClasses: { default: undefined },
    textAlign: { default: 'center' }
  },
  emits: ["click", "mouseenter", "mouseleave", "mousedown", "focus", "blur", "pointerdown"],
  setup(__props: any) {

/**
 * @file It's named "contained button" following Material UI's terminology: https://material.io/components/buttons .
 *
 *
 * This component applies three types of styles:
 *
 * 1. Shape/size
 * 2. Colors
 * 3. Text truncation
 *
 *
 * To make customization easy, it's built so that you can (re)use each group of styles independently,
 * i.e. each type of style is optional. Notice that if you set `:color-scheme="null"`, `:size-preset="null"`
 * and use the default slot, it reduces to `OzBaseButton`.
 *
 */




return { __sfc: true,OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzBaseButton }
}

})